import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Form, Input, Card, Checkbox, Alert } from "antd";
import PhoneInput from "react-phone-input-2";

import classes from "./RegisterCard.module.scss";
import {
  validateMessages,
  cellPhoneValidator,
  startPatternRule,
} from "../../utils/validation";
import { registerAPI } from "../../API/endpoints/auth";
import TermsAndConditions from "./TermsAndCondition";
import ReCaptcha from "./ReCaptcha";

export default function LoginCard() {
  const navigate = useNavigate();

  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [error, setError] = useState();
  const [captchaValue, setCaptchaValue] = useState(null);

  const toggleShowTermsModal = () => {
    setIsTermsModalOpen((prev) => {
      return !prev;
    });
  };

  const onFinish = async (values) => {
    const { terms, captcha, ...formData } = values;
    formData.phone = `+${formData.phone}`;
    try {
      if (!captchaValue) {
        return;
      }
      await registerAPI(formData, captchaValue);
      navigate("/auth/registration-status");
    } catch (error) {
      setError(error);
      setCaptchaValue(null);
    }
  };

  return (
    <Card
      title="CREATE ACCOUNT"
      className={classes.card}
      styles={{
        body: { padding: "16px 24px" },
        header: { minHeight: "36px", paddingTop: 8 },
      }}
    >
      {error && <Alert message={error} type="error" />}
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="horizontal"
        validateMessages={validateMessages}
        size="middle"
        labelAlign="left"
        labelCol={{ flex: "220px" }}
        labelWrap
      >
        <Form.Item
          name="firstName"
          label="Name"
          rules={[{ required: "true", min: 3, max: 20 }, startPatternRule]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>

        <Form.Item
          name="lastName"
          label="Surname"
          rules={[{ required: "true", min: 3, max: 20 }, startPatternRule]}
        >
          <Input placeholder="Enter your surname" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: "true", type: "email" }]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          name="companyName"
          label="Company Name"
          rules={[{ required: "true", max: 50 }, startPatternRule]}
        >
          <Input placeholder="Enter your company name" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[{ required: "true", validator: cellPhoneValidator() }]}
        >
          <PhoneInput
            className="misaligned-arrow"
            inputStyle={{ height: 32 }}
            country={"az"}
            enableSearch={true}
            placeholder="+994 (50) 000-00-00"
          />
        </Form.Item>

        <Form.Item
          name="position"
          label="Position within the Company"
          rules={[{ required: "true", max: 30 }, startPatternRule]}
        >
          <Input placeholder="Enter your position" />
        </Form.Item>

        <Form.Item
          name="terms"
          valuePropName="checked"
          style={{ textAlign: "left", margin: "12px 0" }}
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject("You must accept the Terms and conditions"),
            },
          ]}
        >
          <Checkbox onClick={(e) => e.stopPropagation()}>
            I have read and accept the
            <span
              onClick={(e) => {
                e.preventDefault();
                toggleShowTermsModal();
              }}
              className={classes.clickableSpan}
            >
              Terms and conditions
            </span>
          </Checkbox>
        </Form.Item>

        <ReCaptcha value={captchaValue} onChange={setCaptchaValue} />

        <Form.Item className={classes.submitButton}>
          <Button type="primary" htmlType="submit" block>
            Register
          </Button>
        </Form.Item>

        <div className={classes.login}>
          <span>Already have an account?</span>
          <Link to={"/auth/login"} className={classes.clickableSpan}>
            Login
          </Link>
        </div>
      </Form>
      <TermsAndConditions
        open={isTermsModalOpen}
        onCancel={toggleShowTermsModal}
      />
    </Card>
  );
}
